/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';
import type { AdditionalIdentification } from './AdditionalIdentification';
import {
    AdditionalIdentificationFromJSON,
    AdditionalIdentificationFromJSONTyped,
    AdditionalIdentificationToJSON,
    AdditionalIdentificationToJSONTyped,
} from './AdditionalIdentification';

/**
 * 
 * @export
 * @interface SubscriberCoverageInfo
 */
export interface SubscriberCoverageInfo {
    /**
     * 
     */
    date_range?: DateRange;
    /**
     * 
     */
    additional_identifications?: Array<AdditionalIdentification>;
}

/**
 * Check if a given object implements the SubscriberCoverageInfo interface.
 */
export function instanceOfSubscriberCoverageInfo(value: object): value is SubscriberCoverageInfo {
    return true;
}

export function SubscriberCoverageInfoFromJSON(json: any): SubscriberCoverageInfo {
    return SubscriberCoverageInfoFromJSONTyped(json, false);
}

export function SubscriberCoverageInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriberCoverageInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'date_range': json['date_range'] == null ? undefined : DateRangeFromJSON(json['date_range']),
        'additional_identifications': json['additional_identifications'] == null ? undefined : ((json['additional_identifications'] as Array<any>).map(AdditionalIdentificationFromJSON)),
    };
}

export function SubscriberCoverageInfoToJSON(json: any): SubscriberCoverageInfo {
    return SubscriberCoverageInfoToJSONTyped(json, false);
}

export function SubscriberCoverageInfoToJSONTyped(value?: SubscriberCoverageInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_range': DateRangeToJSON(value['date_range']),
        'additional_identifications': value['additional_identifications'] == null ? undefined : ((value['additional_identifications'] as Array<any>).map(AdditionalIdentificationToJSON)),
    };
}

